import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// 公共页面
import MainLayout from './components/MainLayout';
import NewsDetail from './pages/NewsDetail';
import NotFound from './pages/NotFound';

// 管理后台页面
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import NewsManagement from './pages/admin/NewsManagement';
import ContactManagement from './pages/admin/ContactManagement';
import UserManagement from './pages/admin/UserManagement';
import Analytics from './pages/admin/Analytics';
import Settings from './pages/admin/Settings';
import ContentManagement from './pages/admin/ContentManagement';

// 样式
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* 公共路由 */}
            <Route path="/" element={<MainLayout />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            
            {/* 管理后台登录 */}
            <Route path="/admin/login" element={<Login />} />
            
            {/* 管理后台路由 - 需要认证 */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <Navigate to="/admin/dashboard" replace />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/news" element={
              <ProtectedRoute>
                <NewsManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/contacts" element={
              <ProtectedRoute>
                <ContactManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/content" element={
              <ProtectedRoute>
                <ContentManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/users" element={
              <AdminRoute>
                <UserManagement />
              </AdminRoute>
            } />
            
            <Route path="/admin/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/settings" element={
              <AdminRoute>
                <Settings />
              </AdminRoute>
            } />
            
            {/* 404页面 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;